import tempMeeApi from '../../../apis/tempMee';

/**
 * Fetches job list from the API
 *
 * @param {import('../types/JobList.parameters').IGetJobListParams} params - Cleaned query parameters
 * @returns {Promise<import('../types/JobList.api').IGetJobListApiResponse>} Job list API response
 */
export const getJobList = async (params) => {
  const response = await tempMeeApi.get('admin/jobs', {
    params,
  });
  return response.data;
};
